import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64c62140&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=64c62140&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c62140",
  null
  
)

export default component.exports